/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-03-28",
    versionChannel: "nightly",
    buildDate: "2024-03-28T00:06:11.920Z",
    commitHash: "bb71b61c9ade6c3f185d7f0cc878423402dc4a7f",
};
